import m from 'mithril'
import {
    Dialog,
} from 'components'
import AnswerDialog from './dialog'

class EventDialog {
    constructor(vnode) {
        this.model = vnode.attrs.model
        this.orders = ['A', 'B', 'C', 'D']
        this.select = false
        this.check = false
        // 初始化已選過的選項陣列
        if (!this.model.selectedOptions) {
            this.model.selectedOptions = []
        }
        // 初始化答錯選項陣列
        if (!this.model.wrongOptions) {
            this.model.wrongOptions = []
        }
        // 判斷是否為是非題（只有2個選項）
        this.isTrueFalseQuestion = this.model.items.length === 2
    }
    close(event, value) {
        setTimeout(() => {
            Dialog.close(event)
            m.redraw()
        }, 200)
    }

    view(vnode) {
        return m('.modal-dialog.m-0', {
            style: {
                height: "100vh",
                minWidth: "100%",
                maxWidth: "100%",
            }
        }, [
            m(".modal-content.border-0.rounded-0", {
                style: {
                    height: "100vh"
                }
            }, [
                m(".row.no-gutters.w-100", [
                    m(".col-md-12.py-3", {
                        style: {
                            background: this.model.color
                        }
                    }, [
                        m(".container", [
                            m(".d-flex.justify-content-between", [
                                m("img.img-fluid", {
                                    src: `./img/logo2.png`,
                                    style:{
                                        maxWidth: "250px",
                                        maxHeight: "80px"
                                    }
                                }),
                            ])
                        ])

                    ]),
                    m(".col-md-12", [
                        m(".container", [
                            m(".row.no-gutters.w-100", [
                                m(".col-md-12.pt-5.pb-1.pl-3", [
                                    m("span.font-weight-bold", {
                                        style: {
                                            color: this.model.color,
                                            fontSize: "5rem",
                                            lineHeight: "4.25rem",
                                            fontWeight: 700
                                        }
                                    }, this.model.order),
                                ]),
                                m(".col-md-12.py-2.pl-3", [
                                    m("span.font-weight-bold.pb-1", {
                                        style: {
                                            color: this.model.color,
                                            fontSize: "2rem",
                                            lineHeight: "4.25rem",
                                            borderBottom: "5px " + this.model.color + " solid",
                                            fontWeight: 700
                                        }
                                    }, this.model.question),
                                ]),
                                (this.model.hasOwnProperty("description")) ? [
                                    m(".col-md-12.py-2.pl-3", [
                                        m("span.font-weight-bold.pb-1", {
                                            style: {
                                                color: this.model.color,
                                                fontSize: "1.5rem",
                                                lineHeight: "3.25rem",
                                                // borderBottom: "5px " + this.model.color + " solid",
                                                fontWeight: 700
                                            }
                                        }, this.model.description),
                                    ]),
                                ] : [],
                                this.model.items.map((_item, index) => {
                                    return [
                                        m(".col-md-9.py-1", [
                                            m(".row.no-gutters.w-100.pl-3", {
                                                    style: {
                                                        // background: (this.model.answer == index) ? [(this.select) ? this.model.color : "#FFFFFF"] : "#FFFFFF"
                                                        background: (this.check)
                                                            ? ((this.select === index) ? ((this.select === this.model.answer) ? "#8DEB86" : "#F58E8E") : "#FFFFFF")
                                                            : ((this.select === index) ? this.model.color : (this.model.wrongOptions.includes(index) ? "#FFE5E5" : "#FFFFFF"))
                                                    },
                                                onclick: (e) => {
                                                    e.preventDefault()
                                                    if (!this.check) {
                                                        this.select = index
                                                    }

                                                }
                                            }, [
                                                m(".col-1", [
                                                    m("span.font-weight-bold", {
                                                        style: {
                                                            color: (this.select === index) ? "#FFFFFF" : this.model.color,
                                                            fontSize: "5rem",
                                                            fontWeight: 700
                                                        }
                                                    }, this.orders[index]),
                                                ]),
                                                m(".col-11.d-flex.align-items-center", [
                                                    m("p.m-0", {
                                                        style: {
                                                            color: (this.select === index) ? "#FFFFFF" : "#464646",
                                                            fontSize: "1.75rem",
                                                        }
                                                    }, (typeof _item === 'string') ? m.trust(_item) : _item.text),
                                                ]),
                                            ])
                                        ])
                                    ]
                                })

                            ]),

                            m(".col-12.py-5", [
                                m(".d-flex.align-items-center.justify-content-center", {
                                    style: {
                                        background: (this.select === false) ? "#FFFFFF" : this.model.color,
                                        color: (this.select === false) ? this.model.color : "#FFFFFF",
                                        border: "1px " + this.model.color + " solid",
                                        borderRadius: "30px",
                                        height: "87px",
                                        cursor: "pointer",
                                        width: "280px"
                                    },
                                    onclick: (e) => {
                                        e.preventDefault()
                                        if (this.select !== false) {
                                            // 記錄已選過的選項
                                            if (!this.model.selectedOptions.includes(this.select)) {
                                                this.model.selectedOptions.push(this.select)
                                            }
                                            
                                            // 答對後標記為完成，答錯則記錄錯誤選項
                                            // if (this.select === this.model.answer) {
                                                vnode.attrs.model.isFinish = true
                                            // } else {
                                            //     // 記錄答錯的選項
                                            //     if (!this.model.wrongOptions.includes(this.select)) {
                                            //         this.model.wrongOptions.push(this.select)
                                            //     }
                                            // }
                                            
                                            this.check = true

                                            Dialog.show(AnswerDialog, {
                                                attrs: {
                                                    answer: (this.select === this.model.answer)? true : false,
                                                    model: vnode.attrs.model,
                                                    selectIndex: this.select
                                                },
                                                didHide: (returnValue) => {
                                                    this.close(true)
                                                }
                                            })

                                            
                                        }

                                    }
                                }, [
                                    m("span.font-weight-bold.px-2", { style: { fontSize: "2.5rem", fontWeight: 700 } }, (this.select === false) ? "請先選擇答案" : "看答案")
                                ])
                            ]),

                        ])
                    ]),


                ])
            ]),

        ])
    }
}

export default EventDialog